export default {"src":"/_next/static/image/src/images/about/community-panel-icon-filled.f1ec9360257a314cd57c19ff12778aae.svg","height":82,"width":115};